<div class="row" *ngIf="!hasLoadedAssessments">
  <div class="col-12">
    <p class="alert alert-warning"><app-spin-icon></app-spin-icon> Loading Assessments...</p>
  </div>
</div>
<div class="row" *ngIf="hasLoadedAssessments">
	<div *ngIf="canManageAssessments" class="col">
	<h1 class="h1-responsive">
		Assessments <a class="btn btn-primary" *hasPermission="'SuperUser'" [routerLink]="['new']">Add New Assessment</a>	
	</h1>
	<p *ngIf="Assessments.length == 0">Assessment list is empty</p>
	<table class='table table-striped'>
		<thead class="primary-color text-white">
			<tr>
				<th>Assessment</th>
				<th>Description</th>
				<th *ngIf="tokensEnabled">Tokens</th>
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let assessment of Assessments">
				<td class=''>{{assessment.name}}</td>
				<td class='w-50' [innerHTML]='assessment.description'></td>
				<td class='' *ngIf="tokensEnabled">{{getTokens(assessment)}}</td>
				<td class='w-25'>
					<button *ngIf="canEdit(assessment)" aria-label="Edit" class="btn btn-primary btn-sm" type="button" tabindex="0" [routerLink]="[assessment.uid,'edit']">
						<span aria-hidden="true" class="fa fa-edit"></span>
					</button>
					<button aria-label="View" class="btn btn-primary btn-sm" type="button" tabindex="0" [routerLink]="[assessment.uid,'view']">
						<span aria-hidden="true" class="fa fa-eye"></span>
					</button>
					<!-- We can add this back in when we want to have one item purchasing setup here.
						<button aria-label="Shop" class="btn btn-default" type="button" tabindex="0" [routerLink]="['/admin/shop/checkout']" [queryParams]="{uid: assessment.uid}">
							<span aria-hidden="true" class="glyphicon glyphicon-shopping-cart"></span>
					</button> -->
				</td>
			</tr>
		</tbody>
	</table>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/assessment-list/assessment-list.component.html